export function buildTasksListPath(storeId) {
  return `/tasks.php?store=${encodeURIComponent(String(storeId || ""))}`;
}
